import React from 'react'
import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material'

interface DaySelectProps {
  value: number | null | undefined
  onChange: (day: number | null) => void
  disabled?: boolean
  label?: string
  showNone: boolean
  availableDays?: number[]
}

export const DaySelect = ({
  value,
  onChange,
  disabled = false,
  label = 'Day',
  showNone,
  availableDays
}: DaySelectProps): JSX.Element => {
  const daysToShow = availableDays ?? Array.from({ length: 31 }, (_, i) => i + 1)

  const handleChange = (event: SelectChangeEvent<number>): void => {
    const selectedValue = event.target.value
    onChange((showNone && selectedValue === '') ? null : Number(selectedValue))
  }

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="day-select-label">{label}</InputLabel>
      <Select
        labelId="day-select-label"
        id="day-select"
        value={value === undefined ? '' : value ?? ''}
        label={label}
        onChange={handleChange}
        disabled={disabled}
      >
        {showNone && (
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
        )}
        {daysToShow.map((day) => (
          <MenuItem key={day} value={day}>
            {day}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
